export const MAP_CONFIG_BY_COUNTRY: Record<
  string,
  {
    center: { lat: number; lng: number };
    zoom: number;
  }
> = {
  sv: { center: { lat: 13.794185, lng: -88.899994 }, zoom: 8 },
  gt: { center: { lat: 15.5, lng: -90.25 }, zoom: 7 },
  pa: { center: { lat: 8.4, lng: -80.1 }, zoom: 7 },
};

// Escala de colores por precio: de más bajo (#014B27) a más alto (#05FF8D)
export const PRICE_COLORS = ["#014B27", "#016D3A", "#02A559", "#01DA78", "#05FF8D"];

/** Devuelve el color de relleno según la posición relativa entre min y max de los polígonos actuales */
export const priceColor = (price: number, minPrice: number, maxPrice: number): string => {
  if (minPrice === maxPrice) return PRICE_COLORS[Math.floor(PRICE_COLORS.length / 2)];
  const ratio = Math.min(Math.max((price - minPrice) / (maxPrice - minPrice), 0), 1);
  const index = Math.min(Math.floor(ratio * PRICE_COLORS.length), PRICE_COLORS.length - 1);
  return PRICE_COLORS[index];
};

const isMobile = () => window.innerWidth < 768;
const stroke = () => isMobile() ? 2 : 4;
const strokeHover = () => isMobile() ? 3 : 5;

// Stroke oscuro visible sobre el fondo verde
export const POLYGON_STYLE = {
  strokeColor: "#001a0d",
  strokeOpacity: 1.0,
  strokeWeight: 4,
  fillColor: "#05EE84",
  fillOpacity: 1,
  zIndex: 1,
};

// Polígonos de contexto: mismo color que el fondo del mapa, stroke fino para delimitar
export const BACKGROUND_POLYGON_STYLE = {
  strokeColor: "#002412",
  strokeOpacity: 0.6,
  strokeWeight: 4,
  fillColor: "#00321A",
  fillOpacity: 1,
  clickable: false,
  zIndex: 0,
};

export const POLYGON_HOVER_STYLE = {
  ...POLYGON_STYLE,
  strokeColor: "#FFFFFF",
  strokeWeight: 5,
};

export { stroke, strokeHover };

export const MAP_OPTIONS = {
  streetViewControl: false,
  mapTypeControl: false,
  zoomControl: false,
  gestureHandling: "greedy",
  fullscreenControl: false,
  clickableIcons: false,
  styles: [
    // Tierra
    { featureType: "landscape", elementType: "geometry.fill", stylers: [{ color: "#00321A" }] },
    // Mar
    { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#002412" }] },
    // Oculta todo lo demás: carreteras, POIs, tránsito, labels, administrativo
    { featureType: "road", stylers: [{ visibility: "off" }] },
    { featureType: "poi", stylers: [{ visibility: "off" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ visibility: "off" }] },
  ],
};
